import extractLastOptions from "../../../utils/extract-last-options";
import checkReferenceHooks from "./references/check-reference-hooks";
import getOffset from "./get-offset";
import getOptions from "./get-options";
import { ENV_DEV } from "../../../utils/window";

/**
 * Extract timeline from the string
 * @param {String} input
 * @param {Map<"timeline", ExtractedTimelineDataProps>} map
 * @param {MainClassProps} main
 * @param {Boolean} coords
 */
const extractTimeline = (input, map, main, coords) => {
  let offsetsCount = 0;
  let number = 0;
  let previous = 0;

  const offsets = [];

  const timeline = map.get("timeline") || new Map();

  const timelineData = timeline.get("data");

  const steps = new Map();

  /** Remove outer brackets */
  const sliced = input.slice(1, -1);

  /** Check if input is in timeline-type definition with offset, or a single/sequenced */
  const hasOffset = input.includes("_[");

  const isPercentage = input.includes("%_[");

  /** Get the timeline options */
  const data = extractLastOptions(sliced);

  /** Split into individual steps */
  const split = data.get("rest")?.split("╚") || [];

  /** Number of steps */
  const count = split.length;

  for (const item of split) {
    /** @type {StepProps} */
    const step = new Map();

    step.set("is-iterating", false);
    step.set("offsets", null);
    step.set("last-percents", 0);

    ++offsetsCount;

    const data = getOffset(item, previous, hasOffset, coords);
    const current = data.get("offset");
    const original = data.get("original");

    previous = data.get("previous");

    step.set("offsets", [previous, current]);

    if (!previous) {
      timeline.set("current-offset", [previous, current]);
    }

    step.set("original", original);
    step.set("is-step", true);
    step.set("is-percentage", isPercentage);
    step.set("step-duration", current - previous);

    offsets.push(current);

    previous = current;

    steps?.set(number, step);

    ++number;
  }

  /** Timeline options */
  const options = data.get("options");

  /** Processed timeline options */
  const processed = /** @type {OptionsListMapProps} */ (
    getOptions(options, main, steps.size)
  );

  /** The default duration is the maximal end offset */
  // const offsetsDuration = Math.max(...offsets);

  /** Default timeline parameters and data */
  timeline.set("options", processed);
  timeline.set("steps", steps);
  timeline.set("type", "timeline");
  timeline.set("should-process", true);
  timeline.set("statuses", []);
  timeline.set("steps-percents", []);
  timeline.set("is-timeline", true);
  timeline.set("is-iterating", false);
  timeline.set("is-percentage", isPercentage);
  timeline.set("is-coordinate-based", coords);
  timeline.set("has-defined-offsets", hasOffset);
  timeline.set("offsets-duration", -1);
  timeline.set("o_duration", -1);
  timeline.set("o_iterations", 0);
  timeline.set("o_delay", 0);
  timeline.set("o_pause", 0);
  timeline.set("finished", false);
  timeline.set("started", false);
  timeline.set("last-percents", 0);
  timeline.set("last-overall", 0);
  timeline.set("current-iteration", 0);
  timeline.set("done", true);

  timelineData.set("current-step-number", 0);
  timelineData.set("current-step", timeline.get("steps").get(0));
  timelineData.set("step-count", count);

  // for (const step of steps.values()) {
  //   const options = /** @type {OptionsProps} */ (timeline.get("options"));

  //   if (options) {
  //     const duration = /** @type {DefaultOptionMapProps} */ (
  //       options.get("duration")
  //     );

  //     const resolutions = duration.get("resolutions");
  //   }
  //   // step.set("timeline-duration", offsetsDuration);
  // }

  /** Check if the timeline has `on|` hooks */
  checkReferenceHooks(timeline, processed, false);

  const refs = /** @type {Array<Map<String, any>>} */ (
    main.storage.get("parent-refs")
  );

  refs.push(timeline);

  // if (ENV_DEV && offsetsCount !== count) {
  //   console.error(
  //     `[TorusKit error]: Some steps in the timeline \`${data
  //       .get("rest")
  //       .replace(/╚/g, ", ")
  //       .replace(/%_\[/g, "%:[")}\` are missing a defined percentage offset!`
  //   );
  // }

  return timeline;
};

export default extractTimeline;
